// extracted by mini-css-extract-plugin
export default {"wrap":"announcementVideo_wrap__MeMRx","fullScreen":"announcementVideo_fullScreen__UyEri","icon":"announcementVideo_icon__3THjM"};